import { CreatePageLayout } from 'framework/ui/layout';
import { useParams } from 'react-router-dom';
import { UpdateForm } from 'framework/form';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  CRITICAL_PERIOD_TYPE,
  useNewProjectUrl,
  useProjectSecurityContext,
  useProjectTeamService,
} from 'domain/shared/newProject';
import CriticalPeriodForm from './CriticalPeriodForm';
import { omit } from 'lodash';
import { Box } from '@mui/material';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';
import { useShowContext } from 'framework/show';
import { CriticalPeriodType } from 'domain/shared/newProject/team/types';

const UpdateCriticalPeriodLayout = () => {
  const { id, criticalPeriodId } = useParams();
  const { data } = useShowContext<CriticalPeriodType | null>();
  const criticalPeriod = data.getData();
  const { updateCriticalPeriod, getCriticalPeriodsValidationSchema } = useProjectTeamService();
  const { addMessage } = useMessageService();

  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(() => getUserAlias());

  const { isAccessGranted } = useProjectSecurityContext();
  const { getProjectTeamUrl } = useNewProjectUrl();

  return (
    <UpdateForm
      getDataFunc={() =>
        Promise.resolve({
          id: criticalPeriod?.id,
          title: criticalPeriod?.title,
          startDate: criticalPeriod?.startDate,
          endDate: criticalPeriod?.endDate,
          description: criticalPeriod?.description,
        })
      }
      submitFormFunc={async (_, values) => {
        const response = await updateCriticalPeriod(criticalPeriodId!, omit(values, '__typename'));

        if (response?.message) {
          addMessage(new ErrorMessage(response.message));
          return { error: response.message };
        }

        return { result: response };
      }}
      afterSubmit={{
        message: 'You are awesome! Critical period has been successfully updated.',
        redirect: getProjectTeamUrl(id),
      }}
      getValidationSchemaFunc={getCriticalPeriodsValidationSchema}
    >
      <Box sx={{ '& .show-page__content-inner': { minHeight: '20vh !important' } }}>
        <CreatePageLayout title="Update Critical Period:" isCancelButtonVisible={false} buttons={<></>}>
          <CriticalPeriodForm
            isUpdateForm
            isSystemPeriod={
              criticalPeriod?.type === CRITICAL_PERIOD_TYPE.SYSTEM_CREATED &&
              isAccessGranted(ACCESS_INFO_SECTIONS.CRITICAL_PERIOD, ACCESS_INFO_ACTIONS.PARTIAL_MANAGE)
            }
            canDelete={
              isAccessGranted(ACCESS_INFO_SECTIONS.CRITICAL_PERIOD, ACCESS_INFO_ACTIONS.MANAGE) ||
              (isAccessGranted(ACCESS_INFO_SECTIONS.CRITICAL_PERIOD, ACCESS_INFO_ACTIONS.PARTIAL_MANAGE) &&
                criticalPeriod?.createdBy === currentUserAlias)
            }
          />
        </CreatePageLayout>
      </Box>
    </UpdateForm>
  );
};

export default UpdateCriticalPeriodLayout;
